import { FieldsRenderer } from '@neo/blocks/forms/fields-renderer'
import type { GenericFormType } from '@neo/blocks/forms/types'
import type React from 'react'
import { useMemo } from 'react'
import { z } from 'zod'
import { JsonKeyValueEditor } from '../../components/json-key-value-editor'
import type { HttpRequestNodeData } from '../../types'
import { parseJsonData } from '../../utils/http-request-utils'

type HeaderTabProps = {
  form: GenericFormType<HttpRequestNodeData['config']>
  nodeVars: string[]
}

export const HeaderTab: React.FC<HeaderTabProps> = ({ form, nodeVars }) => {
  // Memoize the parsed initial data to prevent unnecessary recalculations
  const initialData = useMemo(
    () => parseJsonData(form.state.values.http_request.headers),
    [form.state.values.http_request.headers],
  )

  const JsonKeyValueComponent = () => {
    const handleHeadersChange = (
      newHeaders: Record<
        string,
        string | number | boolean | null | Record<string, unknown> | unknown[]
      >,
    ) => {
      form.setFieldValue('http_request.headers', JSON.stringify(newHeaders))
    }
    return (
      <JsonKeyValueEditor
        showSecretVariables
        initialData={initialData}
        nodeVars={nodeVars}
        onChange={handleHeadersChange}
      />
    )
  }

  return (
    <FieldsRenderer
      fields={[
        {
          name: 'http_request.headers',
          type: 'custom',
          label: 'Headers',
          zodValidation: z.string().optional(),
          component: JsonKeyValueComponent,
        },
      ]}
      form={form}
    />
  )
}
